<template>
  <modal name="feedbackConfirmationModal" class="feedbackModal" :height="'auto'">
    <form class="feedback-form" @submit.prevent="handleConfirm">
      <header class="feedback-header">
        <h3 class="title">
          {{$t('confirm_application')}}
        </h3>
        <p class="subtitle">{{$t('feedback_confirmation_description')}}</p>
      </header>

      <div class="field-block">
        <label class="modal-label" for="categoria">{{$t('category')}}</label>

        <v-select
          :options="categoriaOptions"
          v-model="localCategoria"
          :placeholder="$t('select_a_category')"
          :clearable="false"
          :reduce="option => option.value"
          class="modal-select"
        />
      </div>

      <div class="field-block">
        <label class="modal-label" for="confirmation-text">{{$t('justification')}}
          <span v-if="localCategoria === 'Outros'" class="required-asterisk">*</span>
        </label>
        <div class="field text-field">
          <textarea
            id="confirmation-text"
            v-model="localMotivo"
            class="feedback-textarea"
            :class="{ 'error': showError }"
            rows="4"
            :placeholder="$t('change_plate_feedback_min_length_placeholder')"
          ></textarea>
          <div v-if="showError" class="error-message">
            {{$t('change_plate_feedback')}}
          </div>
        </div>
      </div>

      <div class="button-div feedback-button-div">
        <button type="button" class="button ghost" @click="handleCancel">
          <i class="fas fa-times"></i> {{$t('cancel')}}
        </button>

        <button type="submit" class="button" :disabled="!isValid">
          {{$t('confirm')}}
        </button>
      </div>
    </form>
  </modal>
</template>

<script>
import vSelect from "vue-select";

export default {
  name: "FeedbackConfirmationModal",
  	components:{
		'v-select': vSelect,
	},
  props: {
    categoria: {
      type: String,
      default: ""
    },
    motivo: {
      type: String,
      default: ""
    },
    showError: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      categoriaOptions: [
        { label: "A combinação entre os pratos foi ruim", value: "A combinação entre os pratos foi ruim" },
        { label: "Houve repetição de cor", value: "Houve repetição de cor" },
        { label: "Houve repetição de ingredientes", value: "Houve repetição de ingredientes" },
        { label: "Houve repetição de modo de preparo", value: "Houve repetição de modo de preparo" },
        { label: "Houve repetição de mais de uma característica", value: "Houve repetição de mais de uma característica" },
        { label: "Houve repetição de prato", value: "Houve repetição de prato" },
        { label: "Houve repetição de grupo de prato", value: "Houve repetição de grupo de prato" },
        { label: "Para reduzir o custo do cardápio", value: "Para reduzir o custo do cardápio" },
        { label: "Ajustar inconsistência contratual", value: "Ajustar inconsistência contratual" },
        { label: "Outros", value: "Outros" }
      ]
    };
  },
  computed: {
    localCategoria: {
      get() {
        return this.categoria;
      },
      set(value) {
        this.$emit('updateCategoria', value);
      }
    },
    localMotivo: {
      get() {
        return this.motivo;
      },
      set(value) {
        this.$emit('updateMotivo', value);
      }
    },
    isValid() {
      const categoriaValida = this.categoria !== "";
      const motivoValido = this.categoria === "Outros" ? this.motivo.trim().length >= 15 : true; // sempre opcional, exceto "outras"
      return categoriaValida && motivoValido;
    }
  },
  methods: {
    handleConfirm() {
      if (!this.isValid) {
        this.$emit('showError');
        return;
      }
      this.$emit('confirm');
    },

    handleCancel() {
      this.$emit('cancel');
    }
  }
};
</script>

<style scoped lang="less">
@import (reference) url("../../../assets/variables.less");

.feedbackModal {
  z-index: 999 !important;
}

.feedback-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  box-sizing: border-box;
  padding: 14px;
  background: linear-gradient(180deg, rgba(244, 247, 255, 0.55) 0%, #ffffff 24%);
}

.feedback-header {
  border-bottom: 1px solid rgba(33, 33, 70, 0.14);
  padding-bottom: 10px;
}

.title {
  margin: 0;
  color: #1f2b56;
  font-size: 1.02rem;
  font-weight: 700;
}

.subtitle {
  margin: 6px 0 0;
  color: #556390;
  font-size: 0.82rem;
}

.field-block {
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.modal-label{
  font-weight: 700;
  color: #253263;
  font-size: 0.84rem;
}

.modal-select .vs__dropdown-menu {
  height: clamp(9.6rem, 12dvh, 15rem) !important;
}

.modal-select {
  :deep(.vs__dropdown-toggle) {
    border: 1px solid rgba(33, 33, 70, 0.22);
    border-radius: 9px;
    min-height: 38px;
    background: #fff;
  }

  :deep(.vs__selected),
  :deep(.vs__search) {
    color: #212146;
    font-size: 0.86rem;
  }

  :deep(.vs__open-indicator) {
    fill: #37487f;
  }
}

.required-asterisk {
  color: #d7263d;
}

.feedback-textarea {
  width: 100%;
  min-height: 170px;
  border-radius: 9px;
  border: 1px solid rgba(33, 33, 70, 0.2);
  font-size: 0.86rem;
  resize: vertical;
  padding: 10px 11px;
  box-sizing: border-box;
  font-family: inherit;
  color: #212146;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:focus {
    border-color: #212146;
    box-shadow: 0 0 0 3px rgba(33, 33, 70, 0.12);
    outline: none;
  }

  &.error {
    border-color: #d7263d;
    box-shadow: 0 0 0 3px rgba(215, 38, 61, 0.14);
  }
}

.error-message {
  color: #c11f39;
  font-size: 0.74rem;
  font-weight: 700;
  margin-top: 5px;
}

.button-div {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 4px;
  border-top: 1px solid rgba(33, 33, 70, 0.1);
  padding-top: 10px;
}

.button {
  min-width: 130px;
  padding: 7px 14px;
  margin: 0;
  border-radius: 8px;
  font-weight: 700;
  font-size: 0.82rem;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

.ghost {
  background-color: white;
  box-shadow: none;
  color: #d7263d;
  border: 1px solid rgba(215, 38, 61, 0.7);

  &:hover {
    color: #212146;
    border: 1px solid #212146;
  }
}

@media screen and (max-width: 760px) {
  .feedback-form {
    padding: 12px;
  }

  .feedback-textarea {
    min-height: 140px;
  }

  .button-div {
    flex-direction: column-reverse;
  }

  .button {
    width: 100%;
    min-width: 0;
  }
}
</style>
